import styled from "styled-components"
import CloudinaryImage from "components/cloudinary-image"
import { maxWidth } from "utils"

export const Content = styled.div`
  width: 100%;
  position: relative;
  background: #222;
  padding-top: 25%;
  z-index: 2;
  display: grid;

  ${maxWidth.tablet`
    padding-top: 35%;
  `}

  h1 {
    color: #fff;
    text-align: center;
    padding: 0 2rem;
    font-size: 10rem;
    margin-bottom: 5rem;
    z-index: 2;

    ${maxWidth.tablet`
      font-size: 4.2rem;
      margin-bottom: 1rem;
    `}
  }

  p {
    color: #fff;
    z-index: 2;
    font-weight: 500;
    text-align: center;
    line-height: 1.26;
    letter-spacing: -0.2px;
    font-size: 2.3rem;
    margin: 0 auto;
    max-width: 620px;

    ${maxWidth.desktopL`
      font-size: 2rem;
      max-width: 570px;
      margin: auto;
    `}

    ${maxWidth.tablet`
      font-size: 1.8rem;
      margin: 0 auto;
      padding: 0 1.5rem;
    `}
  }
`

export const CategoryItems = styled.div`
  width: 620px;
  margin: 3rem auto 10rem;
  z-index: 2;
  background-color: #222;
  padding: 0.5rem;

  ${maxWidth.desktop`
    margin: 3rem 0 5rem;
    width: 100%;
  `}

  ${maxWidth.tablet`
    margin: 2rem 0 5rem;
  `}

  a {
    display: inline-block;
    color: #fff;
    text-align: center;
    font-size: 1.2rem;
    text-transform: uppercase;
    text-decoration: underline;
    letter-spacing: 0.2rem;
    line-height: 1.17;
    margin: 0.7rem 0;
    width: 25%;
    font-weight: 500;

    ${maxWidth.tablet`
      width: 50%;
    `}
  }
`

export const BackgroundImage = styled(CloudinaryImage)`
  position: absolute;
  top: 0;
  width: 100%;
  padding-bottom: calc(800 / 1440 * 100%);
  z-index: 1;

  img {
    width: 100%;
  }

  ${maxWidth.tablet`
    padding-bottom: calc(420 / 724 * 100%);
  `}
`
